import { constants } from './../app-constants';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { OrdemServicoModel, ClienteModel } from './../model';


@Component({
  selector: 'app-criar-oscliente',
  templateUrl: './criar-oscliente.component.html',
  styleUrls: ['./criar-oscliente.component.css'],
  styles: [
    '::ng-deep  .ui-orderlist .ui-orderlist-list-container{ width: 75%; margin-left:12.5%; margin-right:5% }',
    '::ng-deep .ui-orderlist .ui-orderlist-controls{ display: none }',
    '::ng-deep .ui-orderlist .ui-orderlist-list{ height: 20em }',
    '::ng-deep .ui-panel { width: 75%; margin-left:12%; margin-right:12%  }',
    `.label-cliente { font-size: 16px;  padding-bottom: 7px; padding-top: 7px;
      font-family: Verdana, Geneva, Tahoma, sans-serif; font-weight: bold;}
     .header-cliente { color: cornflowerblue; }
     .button-right-position { margin-top : 10px; margin-left : 78%; }`
  ]
})
export class CriarOSClienteComponent implements OnInit {

  public ordemServico: OrdemServicoModel;
  display: Boolean = false;
  cliente: ClienteModel;
  mask: string;
  documento: string;

  @Output() messageEvent = new EventEmitter<string>();
  constructor(private ordemServico_: OrdemServicoModel,
    private cliente_: ClienteModel, private router: Router) {
      this.ordemServico = ordemServico_;
      this.ordemServico.cliente = cliente_;
    }

  ngOnInit() {
    this.cliente = JSON.parse(localStorage.getItem(constants.clienteKey));
    this.documento = this.cliente.cpf;
    if (this.documento != null) {
      if (this.documento.length <= 13) {
          this.mask = '000.000.000-00';
       } else {
          this.mask = '00.000.000/0000-00';
       }
    }
    this.ordemServico.cliente = this.cliente;
  }
}
